import { Tab as TabType } from './types'
import Tab from './Tab'

export type TabsProps = {
	tabs: TabType[]
	activeTab: string
	changeTab?: (data: any) => void
}

export const FormTabs = ({ tabs, activeTab, changeTab }: TabsProps) => {
	return (
		<div className="flex overflow-x-auto rounded-t-lg border border-seashell [&>*:nth-of-type(n+2)]:border-l [&>*:nth-of-type(n+2)]:border-l-seashell [&>*]:flex-1">
			{tabs.map((tab: any, index: number) => (
				<Tab
					key={index}
					tab={tab}
					handleClick={() => changeTab && changeTab(tab.value)}
					isActive={activeTab === tab.value}
				/>
			))}
		</div>
	)
}
